import React, { Children, cloneElement, useContext } from 'react'

import Context from './context'

interface TitleProps {
  children: React.ReactElement
}

const AccordionTitle: React.FC<TitleProps> = ({ children }) => {
  const { toggle, active } = useContext(Context)
  return cloneElement(Children.only(children), {
    onClick: toggle,
    active
  })
}

export default AccordionTitle
